import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

// WorkComp Component
const WorkComp = ({ step, title, description }) => {
  return (
    <Col xs={12} sm={6} md={6} className="mb-4 d-flex">
    <Card className="h-100 w-100" style={{ border: "none", boxShadow: "none" }}>
      <Card.Body className="text-center" style={{ border: "none", boxShadow: "none" }}>
        <Card.Title style={{ fontSize: '3em',fontWeight:"bold",color:"var(--primary)" }}>{step}</Card.Title>
        <Card.Subtitle className="mb-2" style={{ fontSize: '2.1em' ,fontWeight:"bold",color:"var(--primary)"}}>{title}</Card.Subtitle>
        <Card.Text style={{ fontSize: '0.9em', maxWidth: '19em', margin: '0 auto', textAlign: 'center' }}>
            {description}
          </Card.Text>
      </Card.Body>
    </Card>
  </Col>
  );
}

// Work Component
const Work = () => {
  return (
    <Container className="my-5" id="how-it-works">
      <h2 className="text-center mb-4 homepage-head" >How it works?</h2>
      <Row className="text-center">
        <WorkComp
          step="1"
          title="Submit your essay"
          description="Upload your essay through our secure portal. Provide any specific instructions or grading criteria you'd like us to follow."
        />
        <WorkComp
          step="2"
          title="Expert Review"
          description="Our reviewers carefully evaluate your essay based on the provided guidelines and our comprehensive rubric."
        />
        <WorkComp
          step="3"
          title="Receive Feedback"
          description="Within the chosen turnaround time, you’ll receive a detailed report with constructive feedback, a grade, and suggestions for improvement."
        />
        <WorkComp
          step="4"
          title="Revise and Improve"
          description="Use the feedback to refine your essay. Implement the suggestions and see the improvement in your writing quality and grades."
        />
      </Row>
    </Container>
  );
}

export default Work;
